export const TYPE_MODAL = {
  Create: 'Create',
  Edit: 'Edit',
  Delete: 'Delete',
  View: 'View',
  Other: 'Other',
  EditAddition: 'EditAddition',
  EditCheck: 'EditCheck'
};
